import Vue from 'vue'

import VueBootstrap from '@/bootstrap/'
import { PopinsBus, NotificationBus } from '@spices/pepper'
import Pepper from '@spices/pepper'

import AppStyles from '@/styles/app.scss'

Vue.config.productionTip = false;

Vue.use( Pepper );
Vue.use( PopinsBus );
Vue.use( NotificationBus );
Vue.use( VueBootstrap );
